import { APP_TYPE_STUDIO, APP_TYPE_EXHIBITOR, APP_TYPE } from '@modules/Core';

export const isStudio = () => APP_TYPE === APP_TYPE_STUDIO;
export const isExhibitor = () => APP_TYPE === APP_TYPE_EXHIBITOR;
